import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { Card, CardContent } from "@babackapp/ui/components/card";
import useUpdateShopCustomization from "@babackapp/private-api-client/client/use-update-shop-customization";
import ShopCustomizationForm, {
  FormCustomizationValues,
} from "./shop-customizsation-form.tsx";

export default function ShopCustomizationCard() {
  const { data: shop } = useCurrentShopSuspense();
  const { mutateAsync: update } = useUpdateShopCustomization(shop);

  const onSubmit = (values: FormCustomizationValues) => {
    return update({
      primary_50: values.primary50,
      primary_200: values.primary200,
      primary_400: values.primary400,
      primary_600: values.primary600,
      primary_800: values.primary800,
    });
  };

  return (
    <Card className="w-full">
      <CardContent>
        <ShopCustomizationForm
          onSubmit={onSubmit}
          defaultValues={{
            primary50: shop.preferences.customisation["primary_50"],
            primary200: shop.preferences.customisation["primary_200"],
            primary400: shop.preferences.customisation["primary_400"],
            primary600: shop.preferences.customisation["primary_600"],
            primary800: shop.preferences.customisation["primary_800"],
          }}
        />
      </CardContent>
    </Card>
  );
}
